module.exports = __webpack_public_path__ + "img/Certificate.ede4643c.jpg";